import { Component, OnDestroy, OnInit } from '@angular/core';
import { MealPlansService } from 'app/@core/backend/common/services/CalorieFriend/plan.service';
import { MealPlan, MealPlanData } from 'app/@core/interfaces/common/CalorieFriend/plan';
import { PatientStore } from 'app/@core/stores/patient.store';
import { of, Observable, Subject, forkJoin } from 'rxjs';
import { share, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CalculateMetrics, CopyMealItem } from 'app/BuildOps';
import { MealItem } from 'app/@core/interfaces/common/CalorieFriend/meal';
import { FoodService } from 'app/@core/backend/common/services/CalorieFriend/food.service';
import { FoodData, FoodItemModel } from 'app/@core/interfaces/common/CalorieFriend/food';
import { MacroGoals, Patient, PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { NbToastrService } from '@nebular/theme';
import { MealPlanDay } from 'app/@core/interfaces/common/CalorieFriend/plan-day';
import { MacroGoalsData } from 'app/@core/interfaces/common/CalorieFriend/macro-goals';
@Component({
  selector: 'app-macro-goals',
  templateUrl: './macro-goals.component.html',
  styleUrls: ['./macro-goals.component.scss'],
})
export class MacroGoalsComponent implements OnInit, OnDestroy {
  readonly ERROR_NO_ACTIVE_PLAN = 'Sorry, no active meal plans found.';

  MealCals = 0;
  MealProtein = 0;
  MealCarbs = 0;
  MealNetCarbs = 0;
  MealFats = 0;

  loading = false;
  isDirty = false;

  patient: Patient;

  // currentMealPlanDay: Observable<MealPlanDay>;
  autoMacroGoals: MacroGoals;

  get isMacros100Per(): boolean {
    const total =  Math.floor(this.patient.protein + this.patient.fats + this.patient.carbs);
    return total >= 99 && total <= 101;
  }

  constructor(
    private macroGoalsService: MacroGoalsData,
    private patientStore: PatientStore,
    private foodService: FoodData,
    private patientService: PatientData,
    private toastrService: NbToastrService
  ) {}

  protected readonly unsubscribe$ = new Subject<void>();

  ngOnInit() {
    this.patientStore.onPatientChanged().subscribe({
      next: (patient) => {
        this.patient = { ...patient };
        this.isDirty = false;
        this.refresh();
      },
    });
    const autoMacroGoals$ = this.patientStore.onPatientChanged().pipe(
      switchMap((patient) => {
        if (patient?.id) return this.macroGoalsService.getAutoMacroGoals(patient.id);
        return of(null);
      }),
      takeUntil(this.unsubscribe$),
      share()
    );

    autoMacroGoals$.subscribe({
      next: (res) => {
        this.autoMacroGoals = res;
        
        if (this.patient?.autoFillFromPlan) {
          if (this.autoMacroGoals) {
            this.onAutoFillChange(true);
          } else {
            this.patient.autoFillFromPlan = false;
            //this.onAutoFillChange(false);
          }
        }
        this.refresh();
      },
    });
    /* 
    this.currentMealPlanDay = this.patientStore.onPatientChanged().pipe(
      switchMap((patient) => {
        if (patient?.id) return this.mealPlanService.getCurrentPlanDay(patient.id);
        return of(null);
      }),
      share()
    );

    this.currentMealPlanDay.subscribe({
      next: (mealPlanDay) => {
        this.PrepareMetricsTotalDayMetrics(mealPlanDay);
      },
    }); */
  }

  ngOnDestroy(): void {
    this.unsubscribe$.complete();
  }
  /**
   * Method to update Metrics graph data.
   
  PrepareMetricsTotalDayMetrics(mealPlanDay: MealPlanDay) {
    this.MealCals = 0;
    this.MealProtein = 0;
    this.MealCarbs = 0;
    this.MealNetCarbs = 0;
    this.MealFats = 0;

    const day = mealPlanDay;
    if (day == null || day == undefined) return;
    if (day.meals == null || day.meals == undefined || day.meals.length <= 0) return;

    const allItems$: Observable<FoodItemModel>[] = [],
      allItems: MealItem[] = [];
    for (const meal of day.meals) {
      if (meal.items) {
        for (const item of meal.items) {
          allItems$.push(
            this.foodService.getFoodDefintion(
              item.foodId.toString(),
              (item.selectedServingSizeIndex || 0) + 1,
              item.isCustomFood
            )
          );
          allItems.push(item);
        }
      }
    }

    forkJoin(allItems$).subscribe({
      next: (result) => {
        for (let i in result) {
          const item = allItems[i];
          item.Current = result[i];

          const itemMetrics = CalculateMetrics(item);

          this.MealCals += itemMetrics.MealCals;
          this.MealProtein += itemMetrics.MealProtein;
          this.MealCarbs += itemMetrics.MealCarbs;
          this.MealNetCarbs += itemMetrics.MealNetCarbs;
          this.MealFats += itemMetrics.MealFats;
        }

        
        this.refresh(mealPlanDay);
      },
    });
  }
*/
  onAutoFillChange(checked: boolean) {
    if (this.patient.autoFillFromPlan != checked) {
      this.isDirty = true;
    }
    this.patient.autoFillFromPlan = checked;
    if (checked && this.autoMacroGoals) {
      this.patient = {
        ...this.patient,
        ...this.autoMacroGoals
      }
    }
    
    this.refresh();
  }

  onEnableMacroChange(checked: boolean) {
    let patientNew: Patient = { ...this.patientStore.patient(), enableMacroGoals: checked };
    console.log(checked);
    if (this.patientStore.patient().enableMacroGoals != checked) this.save(patientNew);
  }

  onSave() {
    this.save(this.patient);
  }

  onDirty() {
    this.refresh();
    this.isDirty = true;
  }

  private save(patient: Patient) {
    this.loading = true;
    this.patient.calories = Math.round(this.patient.calories); // calories should be an integer
    this.patientService.update(patient).subscribe({
      next: (patient) => {
        this.loading = false;
        this.patientStore.setPatient(patient);
        this.toastrService.success('Macro goals saved successfully', 'Success');
      },
      error: (err) => {
        this.loading = false;
        this.toastrService.danger('Error saving the macro goals', 'Error');
      },
    });
  }

  private refresh() {
    if (!this.patient) return;

    const { calories = 0, protein = 0, carbs = 0, fats = 0 } = this.patient;

    this.MealCals = calories;
    this.MealProtein = Math.round(this.MealCals * protein / 100 / 4);
    this.MealCarbs = this.MealNetCarbs = Math.round((this.MealCals * carbs) / 100 / 4);
    this.MealFats = Math.round((this.MealCals * fats) / 100 / 9);

  }
}
